module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copy"
    }
  }, [_c('p', {
    staticClass: "CR1"
  }, [_vm._v("© 2024 Alex Draper")]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner without written permission except in the case of brief quotations embodied in critical articles or reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_vm._v("DX® and Clarity, Autonomy, Relationships, and Equity® are trademarks that are registered by DX Learning Solutions LLC (dba "), _c('a', {
    attrs: {
      "href": "http://alex-draper.com",
      "target": "_blank"
    }
  }, [_vm._v("alex-draper.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_c('span', {
    staticClass: "Italics _idGenCharOverride-2"
  }, [_vm._v("CARE to")]), _vm._v(" "), _c('span', {
    staticClass: "Italics _idGenCharOverride-2"
  }, [_vm._v("Win")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('span', {
    staticClass: "Italics _idGenCharOverride-2"
  }, [_vm._v("The 4 Leadership Habits to Build High-Performing Teams")])]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_vm._v("Brown Books Publishing Group")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Dallas, TX / New York, NY")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('a', {
    attrs: {
      "href": "http://www.BrownBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.BrownBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("(972) 381-0009")]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_vm._v("A New Era in Publishing®")]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_vm._v("Publisher’s Cataloging-In-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CR1 ParaOverride-2"
  }, [_vm._v("Names: Draper, Alex, author.")]), _vm._v(" "), _c('p', {
    staticClass: "CR ParaOverride-2"
  }, [_vm._v("Title: CARE to win : the 4 leadership habits to build high-performing teams / Alex Draper.")]), _vm._v(" "), _c('p', {
    staticClass: "CR ParaOverride-2"
  }, [_vm._v("Description: Dallas, TX ; New York, NY : Brown Books Publishing Group, [2024] | Includes bibliographical references.")]), _vm._v(" "), _c('p', {
    staticClass: "CR ParaOverride-2"
  }, [_vm._v("Identifiers: ISBN: 978-1-61254-674-2 | LCCN: 2023950068")]), _vm._v(" "), _c('p', {
    staticClass: "CR ParaOverride-2"
  }, [_vm._v("Subjects: LCSH: Leadership. | Work environment--Psychological aspects. | Teams in the workplace. | Psychology, Industrial. | Industrial productivity. | Employee loyalty. | Success in business. | BISAC: BUSINESS & ECONOMICS / Leadership. | SELF-HELP / Personal Growth / Success.")]), _vm._v(" "), _c('p', {
    staticClass: "CR ParaOverride-2"
  }, [_vm._v("Classification: LCC: HD57.7 .D73 2024 | DDC: 658.4092--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_vm._v("eISBN 978-1-61254-675-9")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("LCCN 2023950068")]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_vm._v("Printed in Canada")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "CR1"
  }, [_vm._v("For more information or to contact the author, please go to")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('a', {
    attrs: {
      "href": "http://www.Alex-Draper.com",
      "target": "_blank"
    }
  }, [_vm._v("www.Alex-Draper.com")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87e558f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04-copy.vue
// module id = 69
// module chunks = 0